package com.example.readingnotes.domain.model

import kotlinx.datetime.Instant

data class Tag(
    val id: Int,
    val name: String,
    val color: String? = null, // HEX color code for tag visualization
    val createdAt: Instant,
    val updatedAt: Instant,
)

data class PostTag(
    val postId: Int,
    val tagId: Int,
    val createdAt: Instant,
)

data class TagWithCount(
    val tag: Tag,
    val postCount: Int,
)
